'use strict';
require('../groups/CompanyGroupCategoryService.js');

function CompanyCustomerPortalsCtrl($scope, groupCategories) {
  $scope.groupCategories = groupCategories;
}

CompanyCustomerPortalsCtrl.resolve = {
  groupCategories: ['$stateParams', 'CompanyGroupCategoryService', function($stateParams, CompanyGroupCategoryService){
    return CompanyGroupCategoryService.query({companyId: $stateParams.companyId, limit: 100}).$promise;
  }],
};

module.exports = CompanyCustomerPortalsCtrl;
angular.module('dokiv')
  .controller('CompanyCustomerPortalsCtrl', ["$scope", "groupCategories", CompanyCustomerPortalsCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/customer-portals/CompanyCustomerPortalsCtrl.js
// module id = 328
// module chunks = 0